/** Identity links are provided by the service, never inferred from account strings. */
export interface ChannelAccount {
  id: string;
  channel: string;
  address: string;
}
export interface PersonDuty {
  state: 'on' | 'off' | 'unknown';
  checkedAt: string;
  expiresAt?: string;
}
export interface ChannelPerson {
  id: string;
  name: string;
  avatar?: string;
  accounts: readonly ChannelAccount[];
  timeZone?: string;
  timeZoneLabel?: string;
  duty?: PersonDuty;
}
export function personDuty(duty: PersonDuty | undefined, now: number) {
  const checked = Date.parse(duty?.checkedAt ?? '');
  const expires = duty?.expiresAt ? Date.parse(duty.expiresAt) : undefined;
  const stale = expires !== undefined && (!Number.isFinite(expires) || expires <= now || expires < checked);
  const known = duty && Number.isFinite(now) && Number.isFinite(checked) && checked <= now && !stale;
  return {
    state: known ? duty.state : 'unknown',
    stale,
    checkedAt: Number.isFinite(checked) ? duty?.checkedAt : undefined,
  } as const;
}
const zoneCities = new Map([
  ['Europe/Moscow', 'Москва'],
  ['Europe/Berlin', 'Берлин'],
  ['Asia/Tokyo', 'Токио'],
  ['Europe/London', 'Лондон'],
  ['Europe/Paris', 'Париж'],
  ['America/New_York', 'Нью-Йорк'],
  ['UTC', 'UTC'],
]);
export function personZone(timeZone: string | undefined, at: number, label?: string): string {
  if (!timeZone || !Number.isFinite(at)) return 'Не указан';
  try {
    const offset = new Intl.DateTimeFormat('en', { timeZone, timeZoneName: 'shortOffset' })
      .formatToParts(new Date(at))
      .find((part) => part.type === 'timeZoneName')
      ?.value.replace('GMT', 'UTC')
      .replace(/^UTC[+-]0$/, 'UTC');
    const canonical = new Intl.DateTimeFormat('ru-RU', { timeZone }).resolvedOptions().timeZone;
    const city =
      label ?? zoneCities.get(canonical) ?? canonical.split('/').at(-1)?.replaceAll('_', ' ') ?? canonical;
    return city + (offset && offset !== city ? ' · ' + offset : '');
  } catch {
    return 'Неизвестный пояс';
  }
}
